import { useQuery } from "@tanstack/react-query";

import { useSupabase } from "@/auth/SupabaseProvider";

import { apiFetch } from "./client";
import type { CatalogueDraftsResponse, CatalogueResponse } from "./types";

/**
 * TanStack Query hooks for the Catalogue browser pages — one per
 * sub-tab. Mirrors the `useUsageSummary` shape in `./usage.ts`; both
 * endpoints are single-fetch reads and we don't refresh on focus
 * (operators trigger a refresh via tab switch / navigation).
 */

export function useCatalogue() {
  const { client } = useSupabase();
  return useQuery({
    queryKey: ["catalogue"],
    queryFn: ({ signal }) =>
      apiFetch<CatalogueResponse>(client, "/api/catalogue", { signal }),
  });
}

export function useCatalogueDrafts() {
  const { client } = useSupabase();
  return useQuery({
    queryKey: ["catalogue-drafts"],
    queryFn: ({ signal }) =>
      apiFetch<CatalogueDraftsResponse>(client, "/api/catalogue/drafts", {
        signal,
      }),
  });
}
